<template>
    <PreLoginView>
        <transition name="fade" mode="out-in">
            <ListLoader v-if="initLoading" />
            <NovaStart :buttonTitle="buttonTitle" v-else-if="step == 'start'" />
            <NovaEmailForm v-else-if="step == 'email'" />
            <NovaScheduleForm v-else-if="step == 'schedule'" />
            <NoveStatus v-else-if="step == 'success'" />
        </transition>
    </PreLoginView>
</template>
<script>
import Vue from 'vue'
import PreLoginView from '@/views/PreLoginView/PreLoginView'
import NovaEmailForm from './components/NovaEmailForm'
import NovaScheduleForm from './components/NovaScheduleForm'
import NoveStatus from './components/NovaStatus'
import NovaStart from './components/NovaStart'
export default {
    components: {
        PreLoginView,
        NovaEmailForm,
        NovaScheduleForm,
        NoveStatus,
        NovaStart
    },
    computed: {
        step() {
            return this.$route.params.step
        }
    },
    data() {
        return {
            initLoading: true,
            buttonTitle: 'GET_FREE_LESSON'
        }
    },
    methods: {
        getRole({ id }, account) {
            if (id) {
                return account.roles.find(
                    r => r.sid == id || r.tid == id || r.pid == id
                )
            }
        },
        async getSchool() {
            const role = this.$store.state.user
            if (!role.jwt) return
            await this.$apiService.getSchool()
        },
        async setFormQuery(account, kid) {
            const kidObject = kid
                ? await this.$api
                      .get(`v1/kids/${kid}?view=true`)
                      .then(({ data }) => data)
                : {}
            const { mail, phone, name, surname } = account
            const { gender, birthday } = kidObject
            const kid_name = kidObject.name
                ? `${kidObject.name} ${kidObject.surname}`
                : undefined
            this.$query.setQuery({
                email: mail,
                phone,
                gender,
                birthday,
                kid_name,
                name: `${name} ${surname}`
            })
            this.$query.removeQuery('jwt')
        },
        async getUserFromJWT(jwt) {
            const decodedJwt = JSON.parse(atob(jwt.split('.')[1]))
            const { kid, region } = decodedJwt
            this.$store.commit('setJWT', jwt)
            this.$store.commit('setRegion', region)
            const account = await this.$apiService.getAccount()
            const role = this.getRole(decodedJwt, account)
            if (role) {
                this.$store.commit('setUser', { user: role })
            }
            return { account, kid }
        },
        async setupForm() {
            try {
                const { jwt } = this.$route.query
                if (jwt) {
                    this.$store.commit('setJWT', jwt)
                    const { kid, account } = await this.getUserFromJWT(jwt)
                    await this.setFormQuery(account, kid)
                }
                await this.getSchool()
                this.$Language.selectLanguage('pl')
                this.initLoading = false
            } catch (error) {
                this.initLoading = false
            }
        }
    },
    mounted() {
        this.setupForm()
    }
}
</script>
